import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PageMeta from '../components/PageMeta';
import ResponsiveVideo from '../components/ui/ResponsiveVideo';

// Import video manifest
import videoManifest from '../utils/videoManifest.json';

// Get yorkies videos from manifest
const yorkiesVideos = videoManifest.yorkies || [];


const AboutWrapper = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background: linear-gradient(135deg, #0a0a14 0%, #1a0a2a 50%, #0a0a14 100%);
`;

const VideoContainer = styled.div`
    max-width: 800px;
    width: 100%;
    margin-bottom: 40px;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(255, 51, 153, 0.3);
    border: 2px solid rgba(255, 51, 153, 0.2);
`;

const StyledVideo = styled.video`
    width: 100%;
    height: auto;
    display: block;
`;

const LovelyText = styled.h1`
    font-size: clamp(3rem, 8vw, 6rem);
    font-family: 'Georgia', 'Times New Roman', serif;
    background: linear-gradient(45deg, #ff3399, #ff6bb3, #ffb3d9, #ff3399);
    background-size: 400% 400%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-align: center;
    margin: 0;
    padding: 20px;
    text-shadow: 0 4px 20px rgba(255, 51, 153, 0.5);
    animation: gradientShift 3s ease-in-out infinite alternate, glow 2s ease-in-out infinite alternate;
    letter-spacing: 2px;
    line-height: 1.2;
    
    @keyframes gradientShift {
        0% {
            background-position: 0% 50%;
        }
        100% {
            background-position: 100% 50%;
        }
    }
    
    @keyframes glow {
        0% {
            filter: drop-shadow(0 0 10px rgba(255, 51, 153, 0.3));
        }
        100% {
            filter: drop-shadow(0 0 30px rgba(255, 51, 153, 0.7));
        }
    }
`;

const AboutPage = () => {
    const [selectedVideoSrc, setSelectedVideoSrc] = useState('');

    useEffect(() => {
        // Select a random video when component mounts
        if (yorkiesVideos.length > 0) {
            const randomIndex = Math.floor(Math.random() * yorkiesVideos.length);
            const video = yorkiesVideos[randomIndex];
            // Construct the src path from the video name
            setSelectedVideoSrc(`/assets/yorkies/${video.name}.mp4`);
        }
    }, []);

    return (
        <AboutWrapper>
            <PageMeta
                title="About"
                description="A curated collection of absolutely not AI-generated Yorkshire Terrier videos. Witness their amazing abilities and undeniable charm."
                canonicalPath="/about"
            />
            <VideoContainer>
                {selectedVideoSrc && (
                    <ResponsiveVideo
                        src={selectedVideoSrc}
                        alt="Yorkshire Terrier doing amazing things"
                        linkToFullRes={true}
                        controls
                        autoPlay
                        muted
                        loop
                        playsInline
                        style={{ width: '100%', height: 'auto', display: 'block' }}
                    />
                )}
            </VideoContainer>
            <LovelyText>I Love Yorkshire Terrier</LovelyText>
        </AboutWrapper>
    );
};

export default AboutPage;